<template>
  <div class="engine-data-chart" :class="{'custom-chart': getSelectedCategory === 'custom'}">
    <div class="engine-data-chart-parent-container">
      <div class="row" v-for="data in channel_data" :key="data.channel_id" v-show="(!data.hasError && showNormalValue) || (data.hasError && showAbnormalValue)">
        <div class="column-check">
          <vs-checkbox v-if="data.kind=='engine'" v-model="engineCheckedChannels" :vs-value="data.channel_id" :color="sdfColor.Blue"></vs-checkbox>
          <vs-checkbox v-if="data.kind=='handling'" v-model="handlingCheckedChannels" :vs-value="data.channel_id" :color="sdfColor.Blue"></vs-checkbox>
        </div>
        <div class="alerm-column">
          <div class="alerm" v-show="getSafelyDisplayMap(data.channel_id).error"></div>
        </div>
        <div class="channel-id-column">
          <div class="channel-id-text" :class="{'error-text': getSafelyDisplayMap(data.channel_id).error}">{{data.channel_id}}</div>
        </div>
        <div class="channel-name-column">
          <div class="channel-name-text" :class="{'error-text': getSafelyDisplayMap(data.channel_id).error}">{{data.kind=='handling' ? getManeuveringJapaneseChannelName(data.channel_id) : data.channel_name}}</div>
        </div>
        <div class="value-column flex justify-end">
          <div class="value-text" :class="{'error-text': getSafelyDisplayMap(data.channel_id).error}">{{getSafelyDisplayMap(data.channel_id).value}}</div>
        </div>
        <div class="unit-column">
          <div class="unit-text" :class="{'error-text': getSafelyDisplayMap(data.channel_id).error}">{{getSafelyDisplayMap(data.channel_id).value ? data.display_unit : "" }}</div>
        </div>
        <div class="status-column flex justify-center">
          <div class="status-text" :class="{'error-text': getSafelyDisplayMap(data.channel_id).error}">{{getSafelyDisplayMap(data.channel_id).status}}</div>
        </div>

        <div :id="'container-parent-'+data.channel_id" class="vs-con-loading__container" style="margin:0;padding:0;">
          <div :id="'container-'+data.channel_id"  style="margin:0;padding:0;"></div>
        </div>

        <div class="chart-control-area">
          <div class="chart-menu-inner-row">
            <!--<span>横軸ズーム</span>-->
            <div class="horizontal-buttons horizontal-zoom-buttons chart-menu-control-area">
              <span>
                <feather-icon
                  icon="MinusSquareIcon"
                  svgClasses="h-6 w-6"
                  class="control-button"
                  :class="{disabled: disableMinusZoomButton}"
                  @click="zoomChannelTime('minus')"
                />
              </span>
              <span>
                <feather-icon
                  icon="PlusSquareIcon"
                  svgClasses="h-6 w-6"
                  class="control-button"
                  :class="{disabled: disablePlusZoomButton}"
                  @click="zoomChannelTime('plus')"
                />
              </span>
            </div>
          </div>
          <div class="chart-menu-inner-row">
            <!--<span>縦軸ズーム</span>-->
            <div class="vertial-buttons vertical-zoom-buttons chart-menu-control-area">
              <div>
                <feather-icon
                  icon="PlusSquareIcon"
                  svgClasses="h-6 w-6"
                  class="control-button"
                  @click="yAxisZoom(data.channel_id, 'plus')"
                />
              </div>
              <div>
                <feather-icon
                  icon="MinusSquareIcon"
                  svgClasses="h-6 w-6"
                  class="control-button"
                  @click="yAxisZoom(data.channel_id, 'minus')"
                />
              </div>
            </div>
          </div>
          <div class="chart-menu-inner-row" v-if="getSelectedCategory === 'custom'">
            <!--<span>表示順</span>-->
            <div class="vertial-buttons chart-menu-control-area">
              <feather-icon
                icon="TriangleIcon"
                svgClasses="h-4 w-4"
                class="control-button arrow-button"
                @click="changeOrder('up', data.channel_id)"
              />
              <feather-icon
                icon="TriangleIcon"
                class="upside-down control-button arrow-button"
                svgClasses="h-4 w-4"
                @click="changeOrder('down', data.channel_id)"
              />
            </div>
          </div>
          <div class="chart-menu-inner-row" v-if="getSelectedCategory === 'custom'">
            <!--<span>削除</span>-->
            <div class="chart-menu-control-area">
              <feather-icon
                icon="Trash2Icon"
                svgClasses="h-6 w-6"
                class="remove-button control-button"
                @click="removeCustomId({channel_id: data.channel_id, channel_name: data.channel_name})"
              />
            </div>
          </div>
          <!--
          <v-popover
            offset="16"
            placement="left"
          >
            <feather-icon
              icon="MoreVerticalIcon"
              svgClasses="h-6 w-6"
              class="remove-button control-button"
              v-tooltip.left-start
            />
            <template slot="popover">
              <div v-close-popover>
                <feather-icon
                  icon="XIcon"
                  svgClasses="h-4 w-4"
                  class="control-button"
                />
              </div>
              <div class="chart-menu-inner-row" v-if="mode!='live'">
                <span>横軸ズーム</span>
                <div class="horizontal-buttons chart-menu-control-area">
                  <span>
                    <feather-icon
                      icon="PlusSquareIcon"
                      svgClasses="h-6 w-6"
                      class="control-button"
                      :class="{disabled: xZoomCount >= 3}"
                      @click="zoomChannelTime('plus')"
                    />
                  </span>
                  <span>
                    <feather-icon
                      icon="MinusSquareIcon"
                      svgClasses="h-6 w-6"
                      class="control-button"
                      :class="{disabled: xZoomCount <= 0}"
                      @click="zoomChannelTime('minus')"
                    />
                  </span>
                </div>
              </div>
              <div class="chart-menu-inner-row">
                <span>縦軸ズーム</span>
                <div class="vertial-buttons chart-menu-control-area">
                  <div>
                    <feather-icon
                      icon="PlusSquareIcon"
                      svgClasses="h-6 w-6"
                      class="control-button"
                      @click="yAxisZoom(data.channel_id, 'plus')"
                    />
                  </div>
                  <div>
                    <feather-icon
                      icon="MinusSquareIcon"
                      svgClasses="h-6 w-6"
                      class="control-button"
                      @click="yAxisZoom(data.channel_id, 'minus')"
                    />
                  </div>
                </div>
              </div>
              <div class="chart-menu-inner-row" v-if="getSelectedCategory === 'custom'">
                <span>表示順</span>
                <div class="vertial-buttons chart-menu-control-area">
                  <feather-icon
                    icon="TriangleIcon"
                    svgClasses="h-4 w-4"
                    class="control-button"
                    @click="changeOrder('up', data.channel_id)"
                  />
                  <feather-icon
                    icon="TriangleIcon"
                    class="upside-down control-button"
                    svgClasses="h-4 w-4"
                    @click="changeOrder('down', data.channel_id)"
                  />
                </div>
              </div>
              <div class="chart-menu-inner-row" v-if="getSelectedCategory === 'custom'">
                <span>削除</span>
                <div class="chart-menu-control-area">
                  <feather-icon
                    icon="Trash2Icon"
                    svgClasses="h-6 w-6"
                    class="remove-button control-button"
                    @click="removeCustomId({channel_id: data.channel_id, channel_name: data.channel_name})"
                  />
                </div>
              </div>
              
            </template>
          </v-popover>
          -->
        </div>
      </div>
    </div>
  </div>
</template>

<script src="https://code.highcharts.com/modules/series-label.js"></script>

<script>
import Vue from 'vue'
import _ from "lodash";
import { db } from "@/firebase/firebaseConfig.js";
import Highcharts from 'highcharts';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';  // チャートのデータがない場合の表示用
NoDataToDisplay(Highcharts);
import moment from "moment";
import SecureDataflowMixin from "@/mixins/SecureDataflowMixin";
import { MappingTableMixin } from "@/mixins/addon/secure-dataflow";
import SecureDataflowService from "@/services/secureDataflowService";
import {createNamespacedHelpers} from "vuex";
const { mapGetters, mapActions, mapState } = createNamespacedHelpers("monitoringVesselEngine");
import WebWorkerForSaveIndexedDB from 'worker-loader!@/utils/secure-dataflow/worker/WebWorkerForSaveIndexedDB.js';


export default {
  name: "engineDataChart",
  mixins: [SecureDataflowMixin, MappingTableMixin],
  props: [
    'channel_data',
    'xAxisValue',
    'showNormalValue',
    'showAbnormalValue',
  ],
  computed: {
    ...mapGetters(["getChannelTimeFrom", "getChannelTimeTo", "getSelectedCategory",]),
    ...mapState({
      mode: state => state.mode,
      monitoringVesselEngineStart: state => state.monitoringVesselEngineStart,
      latestChannelData: state => state.latestChannelData,
      kind: state => state.kind,
      referencedChannelIdMap: state => state.referencedChannelIdMap,
      unsubscribesForChart: state => state.unsubscribesForChart,
      xZoomCount: state => state.xZoomCount,
      xZoomStoredRange: state => state.xZoomStoredRange,
      liveDataTimeRange: state => state.liveDataTimeRange,
      liveDataTimeRangeOptions: state => state.liveDataTimeRangeOptions,
      liveDataTimeRangeIndex: state => state.liveDataTimeRangeIndex,
    }),
    xAxisValueSync: {
      get() {
        return this.xAxisValue;
      },
      set(val) {
        this.$emit('update:xAxisValue', val);
      }
    },
    checkedChannels() {
      return {
        engine: this.engineCheckedChannels,
        handling: this.handlingCheckedChannels,
      }
    },
    disableMinusZoomButton() {
      if (this.mode == "live") {
        return  this.liveDataTimeRangeIndex <= 0
      } else if (this.mode == "date") {
        return this.xZoomCount <= 0
      }
    },
    disablePlusZoomButton() {
      if (this.mode == "live") {
        return  this.liveDataTimeRangeIndex >= this.liveDataTimeRangeOptions.length - 1
      } else if (this.mode == "date") {
        return this.xZoomCount >= 3
      }
    }
  },
  data() {
    return {
      xAxisStartValue: null,
      xAxisEndValue: null,
      chartsMap: {},
      displayMap: {},
      engineCheckedChannels: [],
      handlingCheckedChannels: [],
      unsubscribe: [],
      maxPointX: null,
      movingXAxis: false,
      isLoadingPlotDataMap: {},
      adjustBufferMinutes: 2,
      webWorker: null,
    }
  },
  watch: {
    /**
     * 親コンポーネントからのチャンネルリストの変化に応じて再描画を行うトリガー.
     */
    channel_data() {
      if (!this.channel_data || this.channel_data.length === 0) {
        return;
      }
      let newReferencedChannelIdMap = {} 
      this.channel_data.forEach(c => newReferencedChannelIdMap[c.channel_id] = c.channel_id);
      this.setReferencedChannelIdMap(Object.assign({}, this.referencedChannelIdMap, newReferencedChannelIdMap));

      this.$nextTick(async () => {
        await this.redrawPointData();

        if ( this.mode === 'live' ) {
          await this.unsubscribeFirestoreForChart();
          this.subscribeFirestore();
        }
      });
    },
    maxPointX() {
      if ( this.maxPointX && this.movingXAxis === false  ) {
        this.movingXAxis = true;
        this.$nextTick(() => {

          let liveDataTimeRange = this.liveDataTimeRange ? this.liveDataTimeRange : 60;
          const xAxisStartValue = moment.utc().valueOf() - ( liveDataTimeRange - this.adjustBufferMinutes ) * 60 * 1000;
          const xAxisEndValue = moment.utc(this.xAxisStartValue).valueOf() + liveDataTimeRange * 60 * 1000;

          let chartList = Object.values(this.chartsMap);
          chartList.forEach ( ( chart, index ) => {
            setTimeout(() => { 
              chart.xAxis[0].setExtremes(
                xAxisStartValue ,
                xAxisEndValue ,
              );
              if ( chartList.length -1 === index ) {
                this.maxPointX = null;
                this.movingXAxis = false;
              }
            }, Math.floor( index / 4 ) * 800);
            // chart.tooltip.hide();
          });

          this.xAxisStartValue = xAxisStartValue;
          this.xAxisEndValue = xAxisEndValue;

        });
      }
    }
  },
  methods: {
    ...mapActions([
      "convertPointDataList", "convertChannelDataListForChart", "getChannelMaster", "setReferencedChannelIdMap",
      "pushUnsubscribeForChart", "unsubscribeFirestoreForChart",
      "setChannelTimeFromState",
      "setChannelTimeToState",
    ]),

    async subscribeFirestore() {

      const liveDataTimeRange = this.liveDataTimeRange ? this.liveDataTimeRange : 60;
      const vessel = await SecureDataflowService.getVessel();
      const vesselId = vessel.vessel_info.id;
      let versionInfo = JSON.parse(JSON.stringify(this.kind));
      if ( !versionInfo["engine"].versionName || !versionInfo["handling"].versionName ) {
        Vue.$log.debug("versionInfo re-take.");
        versionInfo = await this.getChannelMaster();
      }

      this.$nextTick(async () => {
        [ "engine", "handling" ].forEach(kind => {

          const unsubscribe = db
            .collection("vessel_channel_data")
            .doc("v_" + vesselId)
            .collection(kind)
            .doc( versionInfo[kind].versionName )
            .collection("data")
            // .where('timestamp', '>', latestTimestamp)  // where と orderbyを使うと遅くなった。
            .onSnapshot(snapshot => {snapshot.docChanges().forEach(diff => {if (diff.type !== 'removed') {

              const channelId = diff.doc.id;
              const docData = diff.doc.data();

              // チャートに座標を追加
              this.appendPointData(channelId, docData, liveDataTimeRange);

              // IndexedDBへの登録をWorkerに依頼
              if ( this.referencedChannelIdMap[channelId] ) {
                this.webWorker.postMessage({channelId: channelId, docData: docData, kind: kind, });
              }

            }});});
          this.pushUnsubscribeForChart(unsubscribe);
        });
      });
    },

    /**
     * ライブモードで新しい生データが投入された時に再描画を指示する.
     */
    async appendPointData(channelId, pointData, liveDataTimeRange) {

      const chart = this.chartsMap[channelId];
      if ( chart ) {
        if ( this.isLoadingPlotDataMap[channelId] ) {
          // ローディング中はアペンドしない。
          return;
        }
        const foundChannelData = this.channel_data.find(x => x.channel_id === channelId);
        if ( foundChannelData ) {

          const convertedPointDataList = await this.convertPointDataList({
            channel_id:           channelId,
            value_number_range:   foundChannelData.value_number_range,
            value_string_options: foundChannelData.value_string_options,
            pointDataList:        [ pointData ],
          });

          if ( convertedPointDataList.length > 0 ) {
            chart.series.forEach(series => {
              if ( series.data && series.data.length >= 0 ) {  // TODO: 2021-04 ０件を表示処理中と判断するかは要検討
                const nowMaxPointX = ( series.data.length === 0 ) ? 0 : series.data[series.data.length-1].x;
                if ( nowMaxPointX < convertedPointDataList[0].x ) { // 時間的に逆転するものは、描画対象から除外。

                  series.addPoint(convertedPointDataList[0]);

                  if ( ( chart.xAxis[0].getExtremes().max - convertedPointDataList[0].x ) < 20 * 1000) {
                    // 右端から20秒未満になったらフラグを立てる。
                    this.maxPointX = convertedPointDataList[0].x;
                  }

                  let point = series.data[series.data.length-1];
                  chart.xAxis[0].drawCrosshair(event, point); 
                  chart.tooltip.refresh(point); 
                }
              }
            });

            foundChannelData.hasError = convertedPointDataList[0].error;
          }
        }
      }
    },

    /**
     * グラフ再描画（遅延表示）.
     */
    async redrawPointData(){

      if ( this.mode !== 'live' && this.getChannelTimeFrom && this.getChannelTimeTo ) {
        // liveモードでなければ、 getChannelTimeFrom getChannelTimeToで設定
        this.xAxisStartValue = moment(this.getChannelTimeFrom).valueOf();
        this.xAxisEndValue = moment(this.getChannelTimeTo).valueOf();
      } else {
        // liveモードか、x軸指定の初期値が設定されていなければ、直近60分〜現在時刻を指定
        let liveDataTimeRange = this.liveDataTimeRange ? this.liveDataTimeRange : 60;
        this.xAxisStartValue = moment.utc().valueOf() - ( liveDataTimeRange - this.adjustBufferMinutes ) * 60 * 1000;
        this.xAxisEndValue = moment.utc(this.xAxisStartValue).valueOf() + liveDataTimeRange * 60 * 1000;
      }

      const channel_data = this.channel_data.slice()

      await Promise.all(
        channel_data.map(
          async channelData => {
            if ( document.getElementById('container-' + channelData.channel_id)) {

              this.isLoadingPlotDataMap[channelData.channel_id] = channelData.channel_id;
              this.$vs.loading({
                container: '#container-parent-' + channelData.channel_id ,
                color: '#2d9cdb',
                background: 'rgba(20, 50, 67, 0.2)',
                scale: 0.6,
              });

              let chart = null;
              if (channelData.value_number_range) { // 数値データかイベントデータかの判断
                const highChartsOptions = this.getHighChartsOption(this.xAxisStartValue, this.xAxisEndValue);
                chart = await this.createChart(highChartsOptions, channelData);
              } else {
                let stringOptions = channelData.value_string_options && channelData.value_string_options.split("/")
                const highChartsOptions = this.getHighChartsOption(this.xAxisStartValue, this.xAxisEndValue, { stringOptions: stringOptions, channelId: channelData.channel_id });
                chart = await this.createChart(highChartsOptions, channelData, 'gantt');
              }
              this.chartsMap[channelData.channel_id] = chart;
            }
          }
        )
      )


      // チャートに座標データ群をあとから押し込む。 ( 空のチャート表示であれば、描画はそれほど遅くないのは確認済 )
      const blockSize            =    5; // APIにまとめて問合わせる時の channel_idの数.
      const initialBlock         =    1; // 初期表示(＝即時表示)させるブロック数.
      const baseDelayMilliSecond = 3000; // 最小遅延ミリ秒.
      const increaseMilliSecond  = 2000; // 遅延実行間隔. APIコールが並列で重なると、n次関数レベルで遅延が蓄積されるので、適度に間隔を空ける。
      const maxDelayMilliSecond  = 8000; // 最大遅延ミリ秒.

      // チャンネルデータの配列をkindごとに分け、さらにblockSizeで分割
      let kinds = ['engine', 'handling']
      let chunkedChannelData = []
      for(let kind of kinds) {
        let filteredData = this.channel_data.filter(element => element.kind == kind)
        filteredData = _.chunk(filteredData, blockSize)
        filteredData.forEach(element => {
          chunkedChannelData.push(element)
        })
      }
      chunkedChannelData.forEach( async ( channelDataBlock, blockIndex )=> {
        const timeOutMillSecond = ( blockIndex < initialBlock ) 
                                  ? 0 
                                  : Math.min( maxDelayMilliSecond, ( baseDelayMilliSecond + increaseMilliSecond * Math.sqrt(blockIndex) ));
        setTimeout(async () => { 
          // 座標データ群の情報をAPIからまとめて取得。（２回目以降はlocalDBから取得）
          const channelDataListForChart = await this.convertChannelDataListForChart({ channelDataBlock: channelDataBlock, mode: this.mode, }).catch(error => {
            // codeが502で返ってきたときはタイムアウトと見なし、通知を出す
            if (error.code == 502 || error.code == 408) {
              this.$vs.notify({
                title: `データ量が多いためタイムアウトしました。対象時間を短くして再度お試しください。`,
                color:'warning',
                iconPack: "feather",
                icon: "icon-x-square"
              });
            }
            return
          });
          channelDataListForChart.forEach((channelDataForChart, index) => {
            const chart = this.chartsMap[ channelDataForChart.channelId ];
            if ( chart && chart.series ) {
              chart.series.forEach(series => {

                  // HighChartsに座標データ群をセット
                  series.setData(channelDataForChart.convertedPointDataList); // 重い処理.

                  delete this.isLoadingPlotDataMap[ channelDataForChart.channelId ];
                  this.$vs.loading.close('#container-parent-' + channelDataForChart.channelId + ' > .con-vs-loading'); 
              });

              // チャート更新時に表示するデータがない場合に通知を表示
              if (channelDataForChart.convertedPointDataList.length <= 0 && channelDataForChart.channelId) {
                const channelData = chunkedChannelData[blockIndex][index];
                const channnelName = channelData.kind =='handling'
                  ? this.getManeuveringJapaneseChannelName(channelData.channel_id)
                  : channelData.channel_name;

                this.$vs.notify({
                  title: `${channelData.channel_id} ${channnelName} の該当期間のデータが存在しませんでした`,
                  color:'warning',
                  iconPack: "feather",
                  icon: "icon-x-square"
                });
              }
            }
          });
        }, timeOutMillSecond );
      });      



    },

    /**
     * チャートオブジェクトを生成.
     */
    async createChart(highChartsOption, channelData, chartType) {
      let self = this;

      // Highcharts実体化.
      const chart = Highcharts.chart("container-" + channelData.channel_id, highChartsOption);

      const map = this.getManeuveringAbbreviationMap();
      let convertConstFlag = _.includes(Object.keys(map), channelData.channel_id);

      // ツールチップ表示イベントで、となりのカラムに詳細情報を転記するメソッドを登録
      chart.options.tooltip.formatter = function() {

        const displayMap = {
          value:  this.point.y,
          status: this.point.status ? this.point.status.replace("E", "") : this.point.status,
          error:  this.point.error,
        };

        if ( chartType === 'gantt' ) {
          // TODO: 操船データ固定値差し替えロジック。必要なくなれば削除。
          let stringOptions = channelData.value_string_options && channelData.value_string_options.split("/");
          displayMap.value = convertConstFlag ? map[channelData.channel_id][stringOptions[this.point.y]] : stringOptions[this.point.y];
        };

        // $setを使って、updateイベントを手動発火させる。
        self.$set(self.displayMap, channelData.channel_id, displayMap);
        
        let time = moment(this.point.x).local().format("YYYY/MM/DD HH:mm:ss");
        return '<br/>' + time;
      }

      // あとで呼び出せるようにID情報を埋め込む
      chart.options.channelId = channelData.channel_id; 
      return chart;
    },

    /**
     * x軸同期.
     * event: マウスイベント
     * type: イベントタイプ(over:軸表示処理、[else]:軸非表示処理)
     */
    async xAxisSync(event, type) {

      const xAxisValue = event.target.x;
      let map = this.chartsMap;
      let xAxisValueSync = xAxisValue;

      let promiseAll = [];
      Object.keys(map).forEach((channelId) => {
        promiseAll.push(new Promise((resolve) => {
          let chart = map[channelId];
          chart.series.forEach((series) => {

            let matchedDataIndex = 0;
            for(let dataIndex = 0; dataIndex < series.data.length; dataIndex++) {
              if( series.data[dataIndex].x <= Math.ceil(xAxisValue / 1000 ) * 1000 ) {
                matchedDataIndex = dataIndex; // マウスイベントで特定したx座標を下回る限り上書き更新 = 基準チャートと同じx座標か、その直前のx座標を特定する。

                if (type === 'over' && series.data[dataIndex].x === xAxisValue && this.xAxisValue !== xAxisValue ) {
                  // x軸情報は他のコンポーネントでも使うので、確定したら親コンポーネントに報告。
                  xAxisValueSync = xAxisValue;
                }
              } 
            }

            let point = series.data[matchedDataIndex];
            if (type === 'over') {
              if ( chart.xAxis[0] ) { chart.xAxis[0].drawCrosshair(event, point); }
              if ( point ) { 
                point.setState('hover'); 
                chart.tooltip.refresh(point);
              }
            } else {
              if ( chart.xAxis[0] ) { chart.xAxis[0].hideCrosshair(); }
              if ( point ) {
                point.setState();
              }
              chart.tooltip.hide();
            }          
          });
          resolve(channelId);
        }));
      });
      await Promise.all(promiseAll);
      this.xAxisValueSync = xAxisValueSync;
    },

    /**
     * グラフのY軸の表示範囲をズームイン・ズームアウトする.
     */
    yAxisZoom(channelId, mode) {
      let chart = this.chartsMap[channelId];

      const zoomValue = chart.options.zoomValue ? chart.options.zoomValue : 1;
      const newZoomValue = (mode === 'plus') 
              ? ( zoomValue > 1 ? zoomValue - 1 :  zoomValue / 2 )
              : ( zoomValue > 1 ? Math.floor(zoomValue + 1) :  zoomValue * 2 );

      const yAxisMinValue = chart.yAxis[0].getExtremes().dataMin; 
      const yAxisMaxValue = chart.yAxis[0].getExtremes().dataMax;


      // a:中央値基準でズームするパターン
      const yAxisDataRange = yAxisMaxValue - yAxisMinValue;
      const yAxisHalfValue = yAxisMinValue + ( yAxisDataRange / 2 ); 
      const newYAxisMaxValue = yAxisHalfValue + ( ( yAxisDataRange / 2 ) * newZoomValue );
      let newYAxisMinValue = yAxisHalfValue - ( ( yAxisDataRange / 2 ) * newZoomValue );
      newYAxisMinValue = newYAxisMinValue < 0 ? 0 : newYAxisMinValue; // データの最小値はマイナスにならない想定

      // b:下限値=０固定でズームするパターン
      // const newYAxisMinValue = 0;
      // const newYAxisMaxValue = yAxisMaxValue * newZoomValue;


      // 希望範囲をHighChartsにセット（その数値通りに採択されるかはHighCharts次第）
      chart.yAxis[0].setExtremes(newYAxisMinValue, newYAxisMaxValue);

      // ズーム値はチャートオブジェクトに記憶させておく。
      chart.options.zoomValue = newZoomValue;
    },

    /**
     * this.displayMapの中身を安全に取得.
     */
    getSafelyDisplayMap(channelId) {
      let displayMap = this.displayMap[channelId] ? this.displayMap[channelId] : {};
      if ( displayMap.value && String(displayMap.value).match(/^[0-9]*\.[0-9]{6,}$/) ){
        displayMap.value = Number(displayMap.value).toFixed(6);  // 小数点以下が多すぎる時の暫定補正.
      }
      return displayMap;
    },

    /**
     * 共通のHighChartsオプション指定を取得.
     */
    getHighChartsOption(xAxisMinValue, xAxisMaxValue, ganttOptions) {
      let self = this;

      // 共通のHighChartsオプション指定
      let highChartsOptions = {
        chart: {
          marginLeft: 0,
          marginRight: 50,
          spacingTop: 20,
          spacingBottom: 12,
          width: 560,
          height: 180,
          events: {
            redraw: function() {
              // チャート再描画時にデータが無い場合にメッセージを表示
              if (!this.hasData()) {
                  this.hideNoData();
                  this.showNoData("該当期間のデータが存在しませんでした");
              }
            },
          }
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        xAxis: {
          type: 'datetime',
          min: xAxisMinValue,
          max: xAxisMaxValue,
          crosshair: true,
          labels: {
            enabled: false
          }
        },
        yAxis: {
          title: {
            text: null
          },
          opposite: true, // y軸の目盛を右側に出す
          labels:{ 
            align:'right', 
            x:0, 
          }, 
          offset : 40, // 目盛数値の表示幅を確保
        },
        tooltip: {
          borderWidth: 0,
          backgroundColor: 'none',
          pointFormat: '{point.x}',
          headerFormat: '',
          shadow: false,
        },
        plotOptions: {
          series: {
            lineWidth: 1, // 散布図でも線をつなげて表示する指定
            turboThreshold: 0, // [8640+]
            point: {
              events: {
                mouseOver: (event) => {
                  self.xAxisSync(event, 'over');
                },
                mouseOut: (event) => {
                  self.xAxisSync(event, 'out');
                }
              }
            }
          }
        },
        series: [{
          type: 'scatter', // デフォルトの'line'だとプロット数が増えるとドットが消えるので、散布図型で表示
          data: [], // 座標データは、各チャートに後からセット.
          fillOpacity: 0.3,
          tooltip: {
            valueSuffix: ' '// + dataset.unit
          }
        }],
        lang: {
            noData: ""  // 初期化時にはデータが無い場合のメッセージを表示しない
        },
        noData: {
          style: {
            fontSize: "1rem"
          }
        }
      };


      // gantt custom
      if ( ganttOptions ) {
        let stringOptions = ganttOptions.stringOptions;
        const channelId     = ganttOptions.channelId;

        // TODO: 操船データ固定値差し替えロジック。必要なくなれば削除。
        const map = self.getManeuveringAbbreviationMap()
        let convertConstFlag = _.includes(Object.keys(map), channelId);
        if (convertConstFlag) {
          stringOptions = Object.values(map[channelId]);
        }

        highChartsOptions['xAxis']['type'] = null;

        highChartsOptions['yAxis'] = {
          title: {
            text: null
          },
          height: 120,
          tickInterval: 1, // カテゴリ名を全部表示させるため、間隔は１。
          min: -1,
          startOnTick: false,
          endOnTick: false,
          opposite: false, // y軸の目盛を左側に出す
          labels:{ 
            step: 1,
            align: 'left', 
            x: 50,
            y: 20,
            formatter: function() {
              return stringOptions[this.value];
            },
          }, 
          offset : 40, // 目盛数値の表示幅を確保
        };

        highChartsOptions['plotOptions']['series']['lineWidth'] = 0;
      }

      return highChartsOptions;
    },

    removeCustomId (obj) {
      this.$emit('confirmRemoveCustomId', obj)
    },
    checkAll () {
      this.channel_data.forEach(channel => {
        if (channel.kind === "engine") {
          if (!_.includes(this.engineCheckedChannels, channel.channel_id)) this.engineCheckedChannels.push(channel.channel_id)
        } else if (channel.kind === "handling") {
          if (!_.includes(this.handlingCheckedChannels, channel.channel_id)) this.handlingCheckedChannels.push(channel.channel_id)
        }
      })
    },
    checkClear () {
      this.engineCheckedChannels = [];
      this.handlingCheckedChannels = [];
    },
    clearDisplayMap () {
      this.displayMap = {};
      this.chartsMap = {};
    },
    changeOrder(direction, channelId) {
      this.$emit('changeOrder', {direction: direction, channelId: channelId})
    },

    /**
     * x軸ズームで開始終了時間をstate保存
     */
    async zoomChannelTime(mode) {
      if (this.mode == "live") {
        this.$emit('zoomLiveChannelTime', mode);
      } else if (this.mode == "date") {
        this.$emit('zoomChannelTime', mode);
      }
    },
  },
  created() {
    this.webWorker = new WebWorkerForSaveIndexedDB();
  },
  beforeDestroy() {
    this.webWorker.terminate();
  }
}


// 2値の場合の長方形プロットシンボル ( customRect2 ) を独自定義.
Highcharts.SVGRenderer.prototype.symbols.customRect2 = (x, y, w, h) => {
  const baseRate = 2;

  const yRate = 4.5 * 2 / baseRate ;
  return [
    'M',  x    , y + h / 2, 
    'L',  x + w, y + h / 2, 
          x + w, y + h / 2 + yRate * h,
          x    , y + h / 2 + yRate * h,
    'Z'];
    // X=0,Y=0 から 右下向かって長方形を展開するような座標指定.
};
if (Highcharts.VMLRenderer) {
  Highcharts.VMLRenderer.prototype.symbols.customRect2 = Highcharts.SVGRenderer.prototype.symbols.customRect2;
}

// 3値の場合の長方形プロットシンボル ( customRect3 ) を独自定義.
Highcharts.SVGRenderer.prototype.symbols.customRect3 = (x, y, w, h) => {
  const baseRate = 3;

  const yRate = 4.5 * 2 / baseRate ;
  return [
    'M',  x    , y + h / 2, 
    'L',  x + w, y + h / 2, 
          x + w, y + h / 2 + yRate * h,
          x    , y + h / 2 + yRate * h,
    'Z'];
    // X=0,Y=0 から 右下向かって長方形を展開するような座標指定.
};
if (Highcharts.VMLRenderer) {
  Highcharts.VMLRenderer.prototype.symbols.customRect3 = Highcharts.SVGRenderer.prototype.symbols.customRect3;
}

</script>

<style lang="scss">
@import url("https://code.highcharts.com/css/highcharts.css");
@import "@/assets/scss/secure-dataflow/_variables.scss";
.error-chart {
  .highcharts-area {
    fill: $red !important;
  }
  .highcharts-graph {
    stroke: $red !important;
  }
}

.engine-data-chart.custom-chart {
  height: calc(100vh - 397px) !important;
}

.engine-data-chart {
  display: flex;
  height: calc(100vh - 337px);
  overflow-y: scroll;

  .upside-down {
    transform: rotateX(180deg);
  }

  .vertial-buttons {
    //display: flex;
    //flex-dire
    width: 21px;
    flex-direction: column;
    align-items: center;
  }
  .chart-menu-inner-row {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    justify-content: center;
  }
  .disabled {
    cursor: default !important;
    color: #626262;
    pointer-events: none;
  }
  .arrow-button {
    height: 18px;
    margin-left: auto;
    margin-right: auto;
  }
  .chart-control-area {
    display: flex;
    flex-direction: column;
    padding-top: 18px;
    height: 180px;
    position: relative;
    align-items: flex-end;
  }

  /*
  .chart-menu-control-area {
    width: 70px;
    margin-left: auto;

    display: flex;

    align-items: flex-end;
    justify-content: flex-end;
  }
  */
  .control-button {
    cursor: pointer;
    display: block;
    width: fit-content;
    align-items: center;
  }

  .vertical-zoom-buttons {
    .control-button {
      height: 21px;
    }
  }

  .horizontal-zoom-buttons {
    display: flex;
    .control-button {
      height: 21px;
    }
  }

  .engine-data-chart-parent-container {
    width: 100%;
  }
  .row {
    overflow-wrap: break-word;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #828282;
  }
  .highcharts-area {
    fill: $blue;
  }
  .highcharts-graph {
    stroke: $blue;
  }
  .highcharts-plot-background {
    stroke: $white;
    stroke-width: 1px;
  }
  .highcharts-background {
    fill: transparent;
  }
  .data-chart-container {
    margin-right: 5px;
    overflow: visible !important;
  }

  .highcharts-grid-line {
    stroke-width: 0px;
  }

  .alerm {
    width: 24px;
    height: 24px;
    border-radius: 20px;
    margin-left: auto;
    margin-right: auto;
    background: #EB5757;
    border: 4px solid #BB4949;
  }

  .column-check {
    padding-left: 13px !important;
  }

  .alerm-column {
    min-width: 70px;
  }

  .channel-id-column {
    min-width: 60px;
  }
  .channel-name-column {
    width: 220px;
  }
  .value-column {
    width: 180px;
    padding-right: 3rem;
    font-size: 18px;
  }
  .unit-column {
    min-width: 80px;
    font-size: 22px;
  }
  .status-column {
    min-width: 80px;
    font-size: 22px;
  }
  .value-text {
    //color: $blue;
    font-size: 22px;
    line-height: 1;
  }
  .zoom-button-column {
    min-width: 17px;
  }
  .highcharts-point {
    //display: none;
    stroke-width: 0px;
  }
  .remove-button {
    margin-top: 5px;
  }


  .error-status {
    background: $red;
  }
  .error-text {
    color: $red;
  }

  .zoom-in-button {
    display: block;
  }
  .chart-button {
    width: 17px;
    height: 17px;
    background: transparent;
    color: $white;
    border-width: 1px;
    border-color: $white;
    border-radius: 2px;
  }

  .highcharts-axis-labels {
    fill: $white;
  }

  .highcharts-grid-line {
    stroke: $blue;
  }

  .highcharts-tooltip-box {
    fill: #828282;
    //stroke: white;
  }

  .highcharts-tooltip text {
    fill: $white !important;
  }

  .highcharts-markers {
    fill: $white;
  }
  
  .data-chart-container-blank {
    width: 605px;
  }

  .highcharts-tick {
    stroke: transparent;
  }

  .highcharts-graph {
    stroke: $white;
    stroke-width: 1px;
  }

  .highcharts-yaxis-labels text {
    fill: $white !important;
  }

  .con-vs-loading {
    z-index: 9;
  }
}


</style>
